export default "__VITE_ASSET__D1rST_Xe__"